import React, { useCallback, useEffect, useState } from 'react';
import cogoToast from 'cogo-toast';

import {
  findLessonByLessonType,
  LESSON_INPUT_OPTIONS,
  LESSON_TYPES,
  useDeleteSbatGroupLessonMutation,
} from 'features/classCreation';
import CreateSbatGroupLessonModal from '../CreateSbatGroupLessonModal';
import Switch from 'components/Switch';

function DiscussionSwitch({ sbatGroup }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [deleteLesson, { isSuccess, error }] =
    useDeleteSbatGroupLessonMutation();
  const academyTopic = sbatGroup.academy_topic;
  const lessons = academyTopic.lessons;
  const discussion = findLessonByLessonType({
    lessons,
    lessonType: LESSON_TYPES.liveLecture,
  });

  const handleModalOpen = useCallback(() => {
    setModalOpen(true);
  }, []);

  const handleModalClose = useCallback(() => {
    setModalOpen(false);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Lesson is successfully deleted!');
    }
  }, [error, isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in deleting the lesson. Please try again later!'
      );
    }
  }, [error, isSuccess]);

  const handleLessonDelete = useCallback(() => {
    if (window.confirm('Are you sure, you want to delete this lesson?')) {
      deleteLesson({ lessonId: discussion?.id, sbatGroupId: sbatGroup.id });
    }
  }, [deleteLesson, discussion?.id, sbatGroup.id]);

  const handleOnChange = useCallback(
    (event) => {
      if (event.target.checked) {
        handleModalOpen();
      } else {
        handleLessonDelete();
      }
    },
    [handleLessonDelete, handleModalOpen]
  );

  return (
    <>
      <CreateSbatGroupLessonModal
        title={LESSON_INPUT_OPTIONS[LESSON_TYPES.liveLecture].label}
        handleClose={handleModalClose}
        lessonType={LESSON_TYPES.liveLecture}
        isOpen={modalOpen}
        sbatGroup={sbatGroup}
      />
      <Switch
        checked={Boolean(discussion)}
        onChange={handleOnChange}
        className="m-l-xs"
        small
      />
    </>
  );
}

export default DiscussionSwitch;
